import React from 'react';
import type {SxProps} from '@mui/material';
import {useLocalization} from 'localization';
import {ColorPalette} from 'theme';
import {Layout} from 'components/layout';
import {Text} from 'components/text';

const textSx: SxProps = {
  color: ColorPalette.burgundy50,
};
export const EmptyListPlaceholder = () => {
  const {t} = useLocalization();
  return (
    <Layout pb={0.5}>
      <Text variant="body2" sx={textSx}>
        {t('general.noItems')}
      </Text>
    </Layout>
  );
};
